export default {"src":"/_next/static/media/peaceOfMind_64.c0a9633f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};